export const GET_DICTIONARY_ALL_REQUEST = 'GET_DICTIONARY_ALL_REQUEST';
export const GET_DICTIONARY_ALL_SUCCESS = 'GET_DICTIONARY_ALL_SUCCESS';
export const GET_DICTIONARY_ALL_ERROR = 'GET_DICTIONARY_ALL_ERROR';
export const GET_DICTIONARY_LIST_REQUEST = 'GET_DICTIONARY_LIST_REQUEST';
export const GET_DICTIONARY_LIST_SUCCESS = 'GET_DICTIONARY_LIST_SUCCESS';
export const GET_DICTIONARY_LIST_ERROR = 'GET_DICTIONARY_LIST_ERROR';
export const ADD_DICTIONARY_REQUEST = 'ADD_DICTIONARY_REQUEST';
export const ADD_DICTIONARY_SUCCESS = 'ADD_DICTIONARY_SUCCESS';
export const ADD_DICTIONARY_ERROR = 'ADD_DICTIONARY_ERROR';
export const GET_DICTIONARY_REQUEST = 'GET_DICTIONARY_REQUEST';
export const GET_DICTIONARY_SUCCESS = 'GET_DICTIONARY_SUCCESS';
export const GET_DICTIONARY_ERROR = 'GET_DICTIONARY_ERROR';
export const UPDATE_DICTIONARY_REQUEST = 'UPDATE_DICTIONARY_REQUEST';
export const UPDATE_DICTIONARY_SUCCESS = 'UPDATE_DICTIONARY_SUCCESS';
export const UPDATE_DICTIONARY_ERROR = 'UPDATE_DICTIONARY_ERROR';
export const DELETE_DICTIONARY_REQUEST = 'DELETE_DICTIONARY_REQUEST';
export const DELETE_DICTIONARY_SUCCESS = 'DELETE_DICTIONARY_SUCCESS';
export const DELETE_DICTIONARY_ERROR = 'DELETE_DICTIONARY_ERROR';
export const EXPORT_DICTIONARY_REQUEST = 'EXPORT_DICTIONARY_REQUEST';
export const EXPORT_DICTIONARY_SUCCESS = 'EXPORT_DICTIONARY_SUCCESS';
export const EXPORT_DICTIONARY_ERROR = 'EXPORT_DICTIONARY_ERROR';
export const SELECT_DICTIONARY = 'SELECT_DICTIONARY';
export const DESELECT_DICTIONARY = 'DESELECT_DICTIONARY';
export const UPDATE_DICTIONARY_LIST_PAGINATION_OPTIONS =
  'UPDATE_DICTIONARY_LIST_PAGINATION_OPTIONS';
export const UPDATE_DICTIONARY_LIST_FILTER_OPTIONS =
  'UPDATE_DICTIONARY_LIST_FILTER_OPTIONS';
export const UPDATE_DICTIONARY_LIST_OPTIONS = 'UPDATE_DICTIONARY_LIST_OPTIONS';
